import _ from 'lodash'; // PDM 不允許的格式

var invalidFilter = [/^-0$/, /^-0\.([0]+)$/];
/**
 * Validate the integer or floating-point number.
 * @param {string} [v] - 數值字串
 * @param {object} condition - 驗證條件設定
 * @param {number} condition.digits - 允許小數點後幾位
 *                                      若無設定: 則不限定位數
 *                                      n: 允許 1 ~ n 位數的輸入 
 *                                      0: 只允許正整數
 *                                      -n: 無效的數值, 視為無設定(即不限定位數)
 * @param {boolean} condition.plus - 是否允許正號 +
 * @param {boolean} condition.minus - 是否允許負號 -
 * 
 * @returns {boolean} True if v is valid, false otherwise.
 */

function validateNumber(v) {
  var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // convert to string
  var _v = typeof v === 'string' ? v : "".concat(v); // check if v is numeric


  if (isNaN(_v)) {
    return false;
  }

  var digits = _.get(condition, "digits", undefined);

  var plus = _.get(condition, "plus", false);

  var minus = _.get(condition, "minus", false); // build the pattern for sign symbols, e.g., ([+-]?), ([-]?)


  var symbols = [];

  if (plus) {
    symbols.push("+");
  }

  if (minus) {
    symbols.push("-");
  }

  var signPattern = symbols.length > 0 ? "([" + symbols.join("") + "]?)" : ""; // get the pattern for the number of digits

  var digitsPattern = "(\\.\\d{1,})?";

  if (!isNaN(digits)) {
    if (parseInt(digits) > 0) {
      digitsPattern = "(\\.\\d{1,".concat(digits, "})?");
    } else if (parseInt(digits) === 0) {
      // only integer is valid
      digitsPattern = "";
    }
  } // filter value by invalid patterns


  for (var i = 0; i < invalidFilter.length; i++) {
    var pattern = invalidFilter[i];

    if (_v.match(pattern)) {
      return false;
    }
  } // combine all patterns


  var regexp = new RegExp("^".concat(signPattern, "(0|[1-9]\\d*)").concat(digitsPattern, "$"));

  if (_v.match(regexp)) {
    return true;
  }

  return false;
}

export { validateNumber };